import type { RowData } from "@tanstack/react-table";
import { flexRender } from "@tanstack/react-table";
import clsx from "clsx";

import styles from "../styles.module.scss";

import type { ITableChildProps } from "@components/organisms/table/types";

export function Tbody<TData extends RowData>({
  tableInstance,
  showRow,
  hasActionCell,
}: ITableChildProps<TData>) {
  return (
    <tbody
      className={clsx([
        styles.tbody,
        showRow && styles.rowCell,
        hasActionCell && styles.actionCell,
      ])}
    >
      {tableInstance?.getCoreRowModel()?.rows?.map((rowEl, index) => {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <tr key={`${rowEl.id}index${index}`} className={styles.tr}>
            {showRow && (
              <td className={styles.td}>
                <div className={styles.cell}>{index + 1}</div>
              </td>
            )}
            {rowEl.getVisibleCells().map((cellEl, index2) => {
              const isEmpty = cellEl?.column?.accessorFn
                ? !cellEl.getValue() &&
                  !(cellEl.column.columnDef as { accessorKey: string })
                    ?.accessorKey
                : false;

              const cellContent = flexRender(
                cellEl.column.columnDef.cell,
                cellEl.getContext(),
              );

              return (
                // eslint-disable-next-line react/no-array-index-key
                <td key={`${cellEl.id}index2${index2}`} className={styles.td}>
                  <div className={styles.cell}>
                    {isEmpty ? "- - -" : <>{cellContent}</>}
                  </div>
                </td>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  );
}
